import React from "react";
import "./../styles/Footer.css";

// img
import logo from "./../assets/PesoPulse.png";
import amazonApp from "./../assets/Appstore.jpg";

// Icons
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <>
    <div className="container-fluid">
      <div className="row py-5 Footer justify-content-start align-items-start">
        <div className="col-md-6 col-12">
          <div className="d-flex flex-column align-items-center justify-content-center system">
            <div className="d-flex align-items-center appName">
              <img className="img-fluid Logo" src={logo} alt="Logo" />
              <p className="mb-0 fw-semibold h3 application">esoPulse</p>
            </div>
            <div className="text-start ps-5 copy">
              <p className="mb-0 text-light">
                Copyright © 2024 Team RadiX - PesoPulse.
              </p>
              <p className="mb-0 text-light">All rights reserved</p>
            </div>
            <div className="buttons">
              <a
                className="btn button-fb"
                href="https://www.facebook.com/profile.php?id=61556271360113"
              >
                <FaFacebook />
              </a>
              <a
                className="btn button-yt"
                href="https://youtu.be/QwLvrnlfdNo?si=zY3tOcIV6533l3Ne"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12 pt-5">
          <div className="row">
            <div className="col-md-6 col-12">
              <h5 className="text-light">Company</h5>
              <ul className="list-unstyled text-light">
                <li>
                  <a className="nav-link" href="#scrollspyfeature">
                    Features
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#scrollspypopulation">
                    Users
                  </a>
                </li>
                <li>
                  <a className="nav-link" href="#scrollspyabout">
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="nav-link"
                    href="https://www.facebook.com/profile.php?id=61556271360113"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-12">
              <h5 className="text-light">Support</h5>
              <ul className="list-unstyled text-light">
                <li>
                  <a
                    className="nav-link"
                    href="https://pesopulse.com/terms-of-service"
                  >
                    Terms and Condition
                  </a>
                </li>
                <li>
                  <a href="https://www.amazon.com/gp/product/B0D6GP4TDH?fbclid=IwZXh0bgNhZW0CMTAAAR00shS9PoNw5nluvqfhjMdVzsExv7jjaHxVJg_hraCL1eJIdl2Le3AWeyQ_aem_AV7zAWLxTeu4AKg51N7MVyl012so5rDEyX-Pgg7SNLJ3M14942QqeMHOE_tB688Bg9-jW4EgVyGjK1fgXd2HYiKW">
                    <img className="img-fluid w-50 pt-2 rounded" src={amazonApp} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Footer;
